import { Routes } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { coreRoutes } from '@next/core-lib/app';
import { DairyYieldScanComponent } from './dairy-yield-scan/components/dairy-yield-scan/dairy-yield-scan.component';
import { DairyYieldScanSummaryComponent } from './dairy-yield-scan/components/dairy-yield-scan-summary/dairy-yield-scan-summary.component';

export const APP_ROUTES: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: DairyYieldScanComponent,
    canActivate: [AtLeastAdvisorRoleGuard],
  },
  {
    path: 'scans/:scanId/summary',
    component: DairyYieldScanSummaryComponent,
    canActivate: [AtLeastAdvisorRoleGuard],
  },
  ...coreRoutes,
];
